var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 632,
    viewBox: "0 0 1440 632",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3385_182279",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -193,
    y: -604,
    width: 1900,
    height: 1600
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -193,
    y: -604,
    width: 1900,
    height: 1599.63,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3385_182279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M660.303 673.826C941.596 504.381 1214.6 951.27 1446.38 673.826C1713.27 354.353 1446.38 -573.798 1446.38 -573.798L112.385 -603C112.385 -603 -462.232 1785.15 112.385 1528.74C419.869 1391.53 364.153 852.221 660.303 673.826Z",
    fill: "#41289E",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.303 673.826C941.596 504.381 1214.6 951.27 1446.38 673.826C1713.27 354.353 1446.38 -573.798 1446.38 -573.798L112.385 -603C112.385 -603 -462.232 1785.15 112.385 1528.74C419.869 1391.53 364.153 852.221 660.303 673.826Z",
    fill: "url(#paint0_linear_3385_182279)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3385_182279",
    x1: 1565,
    y1: 472.5,
    x2: -143,
    y2: 472.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BCBBF",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A6BE5",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.58421f07387da9d20868401a3401f0bc.svg";
export { ForwardRef as ReactComponent };